import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";
import { setIsAccountLogedIn } from "../../redux/reducers/accountSlice";
import {
  setAuthenticatedCredentials,
  setPollingIntervalId,
} from "../../redux/reducers/loginSlice";
import { useAppDispatch } from "../../redux/stateHooks";
import {
  getOAuthTokenInfo,
  oAuthTokenPolling,
} from "../../services/apiService";
import { setAccessTokenToHeader } from "../../services/coreApiService";
import { IOAuthTokenResponse } from "../../types/login.types";
import {
  LocalStorageKeys,
  OAUTH_TOKEN_POLLING_INTERVAL,
} from "../../utils/constant";
import { saveOnStorage } from "../../utils/helpers";

function Login() {
  const [copiedText, copy] = useCopyToClipboard();
  const { signOut } = useAuth();

  const handleCopy = (text: string) => {
    copy(text)
      .then(() => {
        console.log("Copied!");
      })
      .catch((error) => {
        console.error("Failed to copy!", error);
      });
  };

  const navigate = useNavigate();
  const [oAuthTokenResponse, setOAuthTokenResponse] =
    useState<IOAuthTokenResponse>(null);
  const [isLoading, setIsLoading] = useState(false);
  const dispatch = useAppDispatch();

  const handleOAuthTokenRequest = async () => {
    const response = await getOAuthTokenInfo();
    setIsLoading(true);
    setIsLoading(false);
    setOAuthTokenResponse(response.data);
    const pollingIntervalId = setInterval(async () => {
      try {
        const resp = await oAuthTokenPolling({
          device_code: response.data.device_code,
        });
        if (resp.data.access_token) {
          saveOnStorage(LocalStorageKeys.CREDENTIALS, resp.data);
          setAccessTokenToHeader(
            resp.data.access_token,
            resp.data.instance_url
          );
          dispatch(setIsAccountLogedIn(true));
          dispatch(setAuthenticatedCredentials(resp.data));
          navigate("/app-tabs-items-component/loadtable");
        }
      } catch (err) {
        // console.log("err", err);
      }
    }, OAUTH_TOKEN_POLLING_INTERVAL);
    dispatch(setPollingIntervalId(pollingIntervalId));
  };
  const openLink = (url: string) => {
    if (window.__adobe_cep__) {
      // console.log("here....1");
      const csInterface = new window.CSInterface();
      csInterface.openURLInDefaultBrowser(url);
    } else {
      // console.log("here....2");
      // Fallback for browser testing
      window.open(url, "_blank");
    }
  };

  return (
    <div className="contentCntr dark-bg text-white px-2">
      <div className="loginConatiner">
        <div className="loginContent">
          {oAuthTokenResponse?.user_code ? (
            <>
              <div className="flex gap-4 items-center justify-center">
                <h1 className="title">{oAuthTokenResponse?.user_code}</h1>
                {copiedText ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 448 512"
                      className="w-[20px] h-[20px]"
                      fill="#fff"
                    >
                      <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
                    </svg>
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 384 512"
                      fill="#fff"
                      className="w-[20px] h-[20px] cursor-pointer"
                      onClick={() => {
                        handleCopy(oAuthTokenResponse?.user_code);
                      }}
                    >
                      <path d="M280 64l40 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 512c-35.3 0-64-28.7-64-64L0 128C0 92.7 28.7 64 64 64l40 0 9.6 0C121 27.5 153.3 0 192 0s71 27.5 78.4 64l9.6 0zM64 112c-8.8 0-16 7.2-16 16l0 320c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-320c0-8.8-7.2-16-16-16l-16 0 0 24c0 13.3-10.7 24-24 24l-88 0-88 0c-13.3 0-24-10.7-24-24l0-24-16 0zm128-8a24 24 0 1 0 0-48 24 24 0 1 0 0 48z" />
                    </svg>
                  </>
                )}
              </div>
              <h2 className="title">
                Open this
                <span
                  onClick={() => {
                    openLink(oAuthTokenResponse?.verification_uri);
                  }}
                  className="ml-2 mr-2 underline text-blue-600 cursor-pointer"
                >
                  link
                </span>
                in browser (if not already opened) and paste the above code to
                verify yourself.
              </h2>
            </>
          ) : (
            <>
              <h1 className="title">
                Connect to your salesforce account to continue. (v1.3)
              </h1>
              <button
                type="button"
                className={`btn btn-primary btn-lg font-13 mt-3 `}
                onClick={handleOAuthTokenRequest}
                disabled={isLoading}
              >
                Connect
              </button>

              <button
                onClick={signOut}
                className="btn btn-primary ml-2 btn-lg font-13 mt-3"
              >
                Switch Account
              </button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}

export default Login;
